import { useNavigate } from "react-router-dom";
import Landing from "@/pages/Landing";

/**
 * Shared auth shell (login + register): the home page sits behind a blurred
 * backdrop with the auth card centred on top, like Paisa's AuthModal.
 */
export default function AuthPageLayout({ children, layoutTestId = "auth-page-layout" }) {
  const nav = useNavigate();

  return (
    <div data-testid={layoutTestId}>
      <div aria-hidden="true" inert="">
        <Landing />
      </div>
      <div data-scroll-root className="fixed inset-0 z-50 overflow-y-auto">
        <button
          type="button"
          aria-label="Close"
          data-testid="auth-close"
          className="fixed inset-0 bg-background/80 backdrop-blur-sm"
          onClick={() => nav("/")}
        />
        <div className="pointer-events-none relative flex min-h-full items-center justify-center p-4">
          <div className="pointer-events-auto w-full max-w-md">{children}</div>
        </div>
      </div>
    </div>
  );
}
